import { useEffect, useRef } from 'react';

// returns the value that was passed to the hook during the previous rendering
export function usePreviousValue(value) {
    const ref = useRef();
    const previousValue = ref.current;
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return previousValue;
}
